import Layout from '@/layout/index.vue'

const modules = import.meta.glob('../views/**/**.vue')

export const loadView = (view) => {
  let res
  for (const path in modules) {
    const dir = path.split('views/')[1].split('.vue')[0]
    if (dir === view) {
      res = () => modules[path]()
    }
  }
  return res
}

export function filterAsyncRouter(constantRouterMap) {
  const accessedRouters = constantRouterMap.filter(route => {
    if (route.component) {
      if (route.component === 'Layout' || route.component === 'Desktop') { // Layout组件特殊处理
        route.component = Layout
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
  return accessedRouters
}

